import { render, staticRenderFns } from "./ColonyEdit.vue?vue&type=template&id=7a64ca8a&scoped=true&"
import script from "./ColonyEdit.vue?vue&type=script&lang=js&"
export * from "./ColonyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a64ca8a",
  null
  
)

export default component.exports